import CustomCheckoutShippingState, {
    PiyoviAddressType,
    PiyoviValidationInfo,
} from "@MasterBluePrint/Store/Components/CustomCheckoutShipping/CustomCheckoutShippingState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState: CustomCheckoutShippingState = {
    bypassPiyoviAddressValidation: false,
    bypassPiyoviByType: { shipping: false, billing: false },
    keptUnverifiedAddress: false,
    isCheckoutShippingSubmitting: false,
    piyoviValidation: undefined,
};

const reducer = {
    "Components/CustomCheckoutShipping/SetBypassingPiyoviAddressValidation": (
        draft: Draft<CustomCheckoutShippingState>,
        action: {
            isBypassingPiyoviAddressValidation: boolean;
        },
    ) => {
        draft.bypassPiyoviAddressValidation = action.isBypassingPiyoviAddressValidation;
    },
    "Components/CustomCheckoutShipping/SetPiyoviValidationResult": (
        draft: Draft<CustomCheckoutShippingState>,
        action: {
            piyoviValidation: PiyoviValidationInfo;
        },
    ) => {
        draft.piyoviValidation = action.piyoviValidation;
    },
    "Components/CustomCheckoutShipping/ClearPiyoviValidationResult": (
        draft: Draft<CustomCheckoutShippingState>,
    ) => {
        draft.piyoviValidation = undefined;
    },
    "Components/CustomCheckoutShipping/SetKeptUnverifiedAddress": (
        draft: Draft<CustomCheckoutShippingState>,
        action: {
            keptUnverifiedAddress: boolean;
        },
    ) => {
        draft.keptUnverifiedAddress = action.keptUnverifiedAddress;
    },
    "Components/CustomCheckoutShipping/SetIsCheckoutShippingSubmitting": (
        draft: Draft<CustomCheckoutShippingState>,
        action: {
            isCheckoutShippingSubmitting: boolean;
        },
    ) => {
        draft.isCheckoutShippingSubmitting = action.isCheckoutShippingSubmitting;
    },
    "Components/CustomCheckoutShipping/SetBypassPiyoviByType": (
        draft: Draft<CustomCheckoutShippingState>,
        action: {
            addressType: PiyoviAddressType;
            isBypassing: boolean;
        },
    ) => {
        draft.bypassPiyoviByType[action.addressType] = action.isBypassing;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
